import loggerLocal from '@/utils/loggerLocal'
// Import the functions you need from the SDKs you need
//import { getAnalytics } from 'firebase/analytics'
//import { getPerformance } from 'firebase/performance'
//import { initializeAppCheck, ReCaptchaV3Provider } from "@firebase/app-check";
import { GlbCompanyCollectionName, GlbSwVersionCollectionName } from '@functions/models/GlbCostants'
import { initializeApp } from 'firebase/app'
import { ReCaptchaV3Provider, getToken, initializeAppCheck, type AppCheck } from 'firebase/app-check'
import { getAuth } from 'firebase/auth'
import { collection, getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_KEY_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
}
const mode = import.meta.env.MODE
const isProd = import.meta.env.VITE_ISPROD
const prod = import.meta.env.PROD
const viteFile = import.meta.env.VITE_FILE
loggerLocal.info( '* Mode', mode, '* isProd', isProd, '* prod', prod, '* viteFile', viteFile )
let appCheckInstance: AppCheck | null = null

//loggerLocal.info( 'firebaseConfig', firebaseConfig )

export async function initializeAppFirebase () {
  const firebaseApp = initializeApp( firebaseConfig )
  const auth = getAuth( firebaseApp );
  //loggerLocal.info( 'Firebase auth currentUser on init:', auth.currentUser );
  const reCaptchaV3ProviderKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
  //loggerLocal.info( 'ReCaptcha V3 Provider Key:', reCaptchaV3ProviderKey )
  // Inizializza AppCheck subito
  if ( !appCheckInstance )
  {
    appCheckInstance = initializeAppCheck( firebaseApp, {
      provider: new ReCaptchaV3Provider( reCaptchaV3ProviderKey ),
      isTokenAutoRefreshEnabled: true,
    } )
  }
  return {
    firebaseApp,
    appCheckInstance,
    reCaptchaV3ProviderKey,
    auth,
  }
}

// Initialize Firebase
export async function initializeFirebase () {
  const init = await initializeAppFirebase()
  const firebaseApp = init.firebaseApp
  const auth = init.auth

  //const perf = getPerformance(firebaseApp)
  //const analytics = getAnalytics(firebaseApp)
  const functionsFire = getFunctions( firebaseApp, 'europe-west3' )
  const db = getFirestore( firebaseApp )
  const swVersionCollectionRef = collection( db, GlbSwVersionCollectionName )
  //const maintenanceCollectionRef = collection(db, GlbMaintenanceCollectionName)
  const companyCollectionRef = collection( db, GlbCompanyCollectionName )
  //const auth = useFirebaseAuth()
  const reCaptchaV3ProviderKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
  /*const appCheck = initializeAppCheck( firebaseApp, {
    provider: new ReCaptchaV3Provider( reCaptchaV3ProviderKey ),

    // Optional argument. If true, the SDK automatically refreshes App Check
    // tokens as needed.
    isTokenAutoRefreshEnabled: true,
  } )*/
  const appCheck = appCheckInstance
  const storageDefault = getStorage( firebaseApp )
  const storageUser = storageDefault
  const storageCompany = storageDefault
  const storagePublic = storageDefault
  const storageMisc = storageDefault
  return {
    firebaseApp,
    //perf,
    //analytics,
    functionsFire,
    db,
    swVersionCollectionRef,
    //maintenanceCollectionRef,
    companyCollectionRef,
    //auth,
    appCheck,
    storageDefault,
    storageUser,
    storageCompany,
    storagePublic,
    reCaptchaV3ProviderKey,
    storageMisc,
    auth
  }
}



export async function ensureAppCheckReady () {
  if ( !appCheckInstance )
  {
    throw new Error( 'AppCheck non inizializzato' )
  }
  try
  {
    const tokenResult = await getToken( appCheckInstance, false )
    loggerLocal.debug( '✅ App Check token:', tokenResult.token )
  } catch ( error )
  {
    loggerLocal.warn( '⚠️ Errore ottenendo App Check token:', error )
  }
}
